import React from 'react';
import {
  CursoHeroContainer,
  TwoColumns,
  InfoBox,
  Logo,
  Title,
  Subtitle,
  ImageBox,
  CursoButton,
  ButtonWrapper,
  EssentialSection,
  EssentialTextContainer,
  EssentialTitle,
  EssentialParagraph,
  LearningSection,
  SectionTitle,
  LearningGrid,
  ForWhomSection,
  ForWhomContent,
  ForWhomCard,
  ForWhomTitle,
  InvestmentSection,
  InvestmentTitle,
  InvestmentParagraph,
  PriceText,
  LearningCard,
  TestimonialsSection,
  TestimonialsTitle,
  TestimonialsGrid,
  TestimonialCard,
  ContactCtaSection,
  FinalTwoColumns,
  FormContainer,
  CtaContainer,
  SectionTitleDark,
  SectionParagraphDark,
  StyledForm,
  StyledInput,
  StyledTextarea,
  SubmitButton,
  VideoWrapper,
  CtaImage
} from './style';


const learningTopics = [
  "Como identificar e evitar a Inversão de Fluxo",
  "Análise administrativa de projetos",
  "Fundamentos da REN Aneel 1.000 e Lei 14.300",
  "Aspectos jurídicos e o que discutir no Judiciário",
  "Como obter medida liminar",
  "Casos reais e jurisprudência atualizada"
];

const testimonials = [
  {
    text: "Curso direto ao ponto! Consegui reverter a negativa do meu projeto com segurança."
  },
  {
    text: "A Renovera ajudou meu time técnico a montar argumentos sólidos junto à concessionária. Não tivemos mais problemas desde então."
  },
  {
    text: "Conteúdo técnico e jurídico muito bem explicado. Vale cada centavo e pude optar pela contratação do Renô Adviser."
  }
];



const targetAudience = [
  "Integradores e engenheiros",
  "Advogados do setor elétrico",
  "Empresas de energia solar",
  "Profissionais que lidam com homologação"
];

function Curso() {

  const whatsappNumber = '5519996514827';
  const message = 'Olá! Tenho interesse no curso sobre Reversão de Indeferimento e gostaria de mais informações.';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      <CursoHeroContainer>
        <div className="container">
          <TwoColumns>
            <InfoBox>
              <Logo src="/Curso/logo-curso.png" alt="Logo do Curso Renovera" />
              <Title>Curso: REVERSÃO DO INDEFERIMENTO DA HOMOLOGAÇÃO POR INVERSÃO DE FLUXO</Title>
              <Subtitle>Evite a negativa de homologação e domine as estratégias técnicas e jurídicas mais eficazes para proteger seus projetos fotovoltaicos.</Subtitle>
              <ButtonWrapper>
                <CursoButton href={whatsappLink} target="_blank" rel="noopener noreferrer">
                QUERO GARANTIR A MINHA VAGA
              </CursoButton>
              </ButtonWrapper>
            </InfoBox>
            <ImageBox>
             <VideoWrapper>
                    <iframe
                    src="https://www.youtube.com/embed/peBMjCdFfKQ"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                     ></iframe>
                </VideoWrapper>
            </ImageBox>
          </TwoColumns>
        </div>
      </CursoHeroContainer>

   
      <EssentialSection>
        <div className="container">
          <TwoColumns>
            <ImageBox>
              <img src="/Curso/imagem-curso-2.png" alt="Por que o curso é essencial" />
            </ImageBox>
            <EssentialTextContainer>
              <EssentialTitle>POR QUE ESSE CURSO É ESSENCIAL?</EssentialTitle>
              <EssentialParagraph>
                Projetos negados por Inversão de Fluxo representam prejuízos. Aprenda como evitar e reverter essas situações com uma abordagem prática, técnica e jurídica.
              </EssentialParagraph>
            </EssentialTextContainer>
          </TwoColumns>
        </div>
      </EssentialSection>

      <LearningSection>
        <div className="container">
          <SectionTitle>VOCÊ VAI APRENDER:</SectionTitle>
          <LearningGrid>
            {learningTopics.map((topic, index) => (
              <LearningCard key={index}>
                {topic}
              </LearningCard>
            ))}
          </LearningGrid>
        </div>
      </LearningSection>

       <ForWhomSection>
        <div className="container">
          <ForWhomContent>
            <ForWhomTitle>PARA QUEM É ESSE CURSO?</ForWhomTitle>
         
            {targetAudience.map((audience, index) => (
              <ForWhomCard key={index}>
                {audience}
              </ForWhomCard>
            ))}
          </ForWhomContent>
        </div>
      </ForWhomSection>

       <InvestmentSection>
        <div className="container">
          <InvestmentTitle>QUAL O VALOR DO INVESTIMENTO?</InvestmentTitle>
          <InvestmentParagraph>
            Você terá acesso a todo o conteúdo técnico e jurídico, incluindo os bônus exclusivos, por apenas:
          </InvestmentParagraph>
          <PriceText>
          R$ 59,90
          </PriceText>
          <ButtonWrapper>
            <CursoButton href={whatsappLink} target="_blank" rel="noopener noreferrer">
                QUERO ME INSCREVER AGORA 
              </CursoButton>
          </ButtonWrapper>
        </div>
      </InvestmentSection>

   
      <TestimonialsSection>
        <div className="container">
          <TestimonialsTitle>O QUE DIZEM OS ALUNOS</TestimonialsTitle>
          <TestimonialsGrid>
            {testimonials.map((testimonial, index) => (
              <TestimonialCard key={index}>
                "{testimonial.text}"
              </TestimonialCard>
            ))}
          </TestimonialsGrid>
        </div>
      </TestimonialsSection>

     
      <ContactCtaSection>
        <div className="container">
          <FinalTwoColumns>
        
            <FormContainer>
              <SectionTitleDark>FICOU COM ALGUMA DÚVIDA?</SectionTitleDark>
              <SectionParagraphDark>
                Envie sua pergunta e nossa equipe entrará em contato com você o mais rápido possível.
              </SectionParagraphDark>
              <StyledForm action="mailto:rodrigo.garcia@renovera.com.br,leonardo.amaral@renovera.com.br?subject=Dúvida%20do%20Curso%20-%20Reversão%20de%20Indeferimento" method="post" encType="text/plain">
                <StyledInput type="text" name="nome" placeholder="Seu nome" required />
                <StyledInput type="email" name="email" placeholder="Seu e-mail" required />
                <StyledTextarea name="duvida" placeholder="Digite sua dúvida aqui" required></StyledTextarea>
                <SubmitButton type="submit">ENVIAR SUA DÚVIDA</SubmitButton>
              </StyledForm>
            </FormContainer>

         
            <CtaContainer>
              <SectionTitleDark>GARANTA SUA VAGA AGORA</SectionTitleDark>
              <SectionParagraphDark>
                Não espere seu projeto ser negado. Esteja preparado com as estratégias certas e o suporte de um time especialista.
              </SectionParagraphDark>
              <CursoButton href={whatsappLink} target="_blank" rel="noopener noreferrer">
                QUERO ME INSCREVER AGORA 
              </CursoButton>
              <CtaImage src="/Curso/imagem-curso-5.png" alt="Garanta sua vaga" />
            </CtaContainer>
          </FinalTwoColumns>
        </div>
      </ContactCtaSection>
    </>
  );
}


export default Curso;